import { c as _c } from "react/compiler-runtime";
import { cn } from "@local/utils/src/cn";
import { barlowCondensed } from "../../utils";
import { ArrowLeftIcon } from "./icons";
import type { HTMLAttributes } from "react";
export interface ArrowTitleProps extends HTMLAttributes<HTMLHeadingElement> {
  headline: string;
  iconClassName?: string;
}
export const ArrowTitle = t0 => {
  const $ = _c(14);
  let headline;
  let iconClassName;
  let props;
  if ($[0] !== t0) {
    ({
      headline,
      iconClassName,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = headline;
    $[2] = iconClassName;
    $[3] = props;
  } else {
    headline = $[1];
    iconClassName = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== iconClassName) {
    t1 = cn("top-3 -left-12 mr-2 hidden w-9 rotate-180 text-gray-200 md:absolute md:mr-0 xl:block", iconClassName);
    $[4] = iconClassName;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = <ArrowLeftIcon className={t1} />;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== headline) {
    t3 = <span dangerouslySetInnerHTML={{
      __html: headline
    }} />;
    $[8] = headline;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== props || $[11] !== t2 || $[12] !== t3) {
    t4 = <h2 className={`${barlowCondensed.className} flex text-4xl leading-tight tracking-[-0.02em] uppercase md:relative md:text-5xl`} {...props}>{t2}{t3}</h2>;
    $[10] = props;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};